import React, {useState} from 'react';
import {IconButton} from '@mui/material';
import UserAvatar from "./UserAvatar";
import UserMenu from "./UserMenu";
import {useUser} from "../../user/UserUtil";
import ChangePasswordDialog from "../user/ChangePasswordDialog";
import AboutDialog from "./AboutDialog";
import MyUserDetails from "../user/MyUserDetails";

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function UserProfileButton() {

    const user = useUser();
    const [isUserMenuVisible, setIsUserMenuVisible] = useState(false);
    const [isChangePasswordVisible, setIsChangePasswordVisible] = useState(false);
    const [showAboutVisible, setShowAboutVisible] = useState(false);
    const [isUserDetailsVisible, setIsUserDetailsVisible] = useState(false);

    const toggleUserMenu = () => {
        setIsUserMenuVisible(!isUserMenuVisible);
    };

    const hideUserMenu = () => {
        setIsUserMenuVisible(false);
    };

    return (
        <>
            <UserMenu isVisible={isUserMenuVisible} user={user} onHide={hideUserMenu}
                      setIsChangePasswordVisible={setIsChangePasswordVisible}
                      showAbout={() => setShowAboutVisible(true)}
                      setIsUserDetailsVisible={() => setIsUserDetailsVisible(true)}/>
            {isChangePasswordVisible && <ChangePasswordDialog shouldDialogShow={isChangePasswordVisible}
                                                              afterChange={(changed) => setIsChangePasswordVisible(false)}/>}
            {showAboutVisible && <AboutDialog onClose={() => setShowAboutVisible(false)}/>}
            {isUserDetailsVisible && <MyUserDetails onClose={() => setIsUserDetailsVisible(false)}/>}
            <IconButton
                size="large"
                type='button'
                onClick={toggleUserMenu}
                color="inherit"
                style={squareHighlightStyle}
            >
                {user && <UserAvatar hideStatus user={user} tooltip={user.displayName}/>}
            </IconButton>
        </>
    );
}
